import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import { ModalController } from '@ionic/angular';
import { FileMeta } from 'src/app/services/types/file-meta.model';
import { DataService } from 'src/app/services/data/data.service';
@Component({
  selector: 'app-modal-uploader',
  templateUrl: 'modal-uploader.component.html',
  styleUrls: ['./modal-uploader.component.scss'],
  providers: [DataService, DatePipe],
})
export class ModalUploaderComponent implements OnInit {
  uploadedFiles: FileMeta[];
  drId?: number;
  ospId?: number;
  cpId?: number;
  title?:string;

  shown?: string ;

  get managementFiles(): FileMeta[] {
    return this.uploadedFiles?.filter((file) => file.from != 'Field');
  }
  get fieldFiles(): FileMeta[] {
    return this.uploadedFiles?.filter((file) => file.from == 'Field');
  }

  categories = ['Redline map', 'Cutsheet', 'Picture', 'Other'];
  files: any[] = [];

  constructor(
    private modalCtrl: ModalController,
    private datePipe: DatePipe,
    private dataService: DataService
  ) {}
  ngOnInit(): void {
    if(this.drId){
      this.shown = '2';
    } else {
      if(this.managementFiles.length<=5){
        this.shown = '1';
      }
    }
  }

  showAcc(acc: string) {
    if (!this.shown) {
      this.shown = acc;
      return;
    }

    if (this.shown == acc) {
      this.shown = undefined;
      return;
    }

    this.shown = acc;
    return;
  }
  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  async confirm() {
    const res = await this.files.forEach((file) => {
      const formData = new FormData();
      formData.append(file.name, file);
      if(file.category)formData.append("category", file.category);
      formData.append("ospId", this.ospId.toString());
      formData.append("cpId", this.cpId.toString());
      if(file.description)formData.append("description", file.description);
      if(this.drId) formData.append("drId", this.drId?.toString());
      formData.append("uploadedFromWhere", 'Field');
      formData.append("uploadingManagerId", 'Field');

      return this.dataService
        .postFile(this.ospId, formData)
        .subscribe((res) => console.log(res),
      err=>this.modalCtrl.dismiss("error", 'cancel'));
    });

    return this.modalCtrl.dismiss('confirm', 'confirm');
  }

  /**
   * on file drop handler
   */
  onFileDropped($event:File[]) {
    this.prepareFilesList($event);
  }

  transformDate(date: string) {
    const dateString = this.datePipe.transform(date, 'MM-dd-yyyy');
    return dateString;
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: File[]) {
    for (const item of files) {
      this.files.push(item);
    }
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  downloadFile(fileName, src) {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = src;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    }

    /**
     * "Design Map"-type files get a Create Redline link (category casing varies in QB data)
     */
    isDesignMap(file: FileMeta): boolean {
      return file.category?.trim().toLowerCase() == 'design map' && !!file.link;
    }

    /**
     * Open the file in the Beacon redline (PDF mark-up) editor.
     * Prefers the QB "Redline Link" formula field (so the editor URL can be
     * changed in QuickBase without a deploy); falls back to building the URL
     * from the file link if the field is absent.
     */
    openRedline(file: FileMeta) {
      const url = file.redlineLink || 'https://beacon.lh.tech/m/redlines/open?url=' + file.link;
      window.open(url, '_blank');
    }

    fileTriggerName(by:string, file:FileMeta){
      return `${by}-${file.name}-${file.rid}`
    }
}
